import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Headline = () => {
  return (
    <Box>
      <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'textSecondary'}
        align={'center'}
      >
        
      </Typography>
      <Typography variant="h4" align={'center'} fontWeight={700} gutterBottom>
      Credentia
      </Typography>
      <Typography variant="h6" align={'center'} color={'textSecondary'}>
        
      </Typography>
    </Box>
  );
};

export default Headline;